import { render } from "./PageWrapper.vue?vue&type=template&id=c745a504&ts=true"
import script from "./PageWrapper.vue?vue&type=script&lang=ts"
export * from "./PageWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__